import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Tooltip,
  Input,
  Spinner,

  Typography,
} from "@material-tailwind/react"
import React, { useEffect, useState } from "react"
import Papa from "papaparse"
import { DEFAULTPRIMARYCOLOR } from "../../../util"

import { toast } from "react-toastify"
import dayjs from "dayjs";

import { CustomHeader } from "../../../components/headers/CustomHeader"
import { BiSearch } from "react-icons/bi"
import { DASHBOARD_USERTYPE } from "../../../types/role"
import moment from "moment"
import { useSelector } from "react-redux"
import { RootState } from "../../../store/store"
import { COMMISSIONAGGREGATE, COMMISSIONAGGREGATENEW } from "../../../GraphQl/queries"
import { CommissionAggregateType } from "../../../types/query"
import { useQuery } from "@apollo/client"
import { getColorCode } from "../../../colorCodes"
import PerPageAndPagination from "../../../components/paginations/perpageAndPagination"
import { FiDownloadCloud } from "react-icons/fi"

type ResponseType = {
  "Transaction Ref": string
  "Transaction Id": string
  "Transaction Date": string
  "Policy Number": string
  "Payment Date": string
  Policyholder: string
  Payee: string
  "Class/Subclass": string
  "Basic Premium": number
  "Commission Rate": string
  "Gross Commission": number
  "Tax Amount": number
  "Net Commission": number
  RiskID: string
}

const PaidCommissions = () => {
  const [searchText, setSearchText] = useState("")
  const [token] = useState()
  const [loading, setLoading] = useState(true)
  const [selectedThick, setSelectedThick] = useState<ResponseType[] | []>([])
  const [commissions, setCommissions] = useState<ResponseType[]>([])
  const [totalAmount, setTotalAmount] = useState(0);

  const defaultStart = moment().subtract(1, "months").format("YYYY-MM-DDTHH:mm");
  const defaultEnd = moment().format("YYYY-MM-DDTHH:mm");
  const [startDate, setStartDate] = useState(defaultStart);
  const [endDate, setEndDate] = useState(defaultEnd);
  const [tempStartDate, setTempStartDate] = useState(defaultStart);
  const [tempEndDate, setTempEndDate] = useState(defaultEnd);
  const [isFilterLoading, setIsFilterLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [searchData, setSearchData] = useState<ResponseType[] | undefined>(undefined);
  const [searchFilterStart, setSearchFilterStart] = useState("");
  const [searchFilterEnd, setSearchFilterEnd] = useState("");

  const handleStartDateChange = (event: any) => {
    const value = event.target.value
    if (value) {
      const formattedValue = value + ":00Z" // Append seconds and 'Z' for timezone
      setStartDate(formattedValue)

    }
    else {
      setStartDate("")
    }

  }

  const handleEndDateChange = (event: any) => {
    const value = event.target.value
    if (value) {
      const formattedValue = value + ":00Z" // Append seconds and 'Z' for timezone
      setEndDate(formattedValue)
    }
    else {
      setEndDate("")
    }
  }

  const handleTempStartDateChange = (event: any) => {
    const value = event.target.value
    if (value) {
      const dateOnly = value.split("T")[0]; // Extract just the date part
      const formattedValue = `${dateOnly}T00:00`; // Set time to 12:00 AM
      setTempStartDate(formattedValue);
    }
  }

  const handleTempEndDateChange = (event: any) => {
    const value = event.target.value
    if (value) {
      const formattedValue = value
      setTempEndDate(formattedValue)
    }
  }

  const handleDateChange = () => {
    setStartDate(defaultStart);
    setEndDate(defaultEnd);
    const start = dayjs(tempStartDate);
    const end = dayjs(tempEndDate);
    const diffInMonths = end.diff(start, 'month', true);

    setIsFilterLoading(true);
    if (searchData !== undefined) {
      setSearchFilterStart(tempStartDate)
      setSearchFilterEnd(tempEndDate)
      setIsFilterLoading(false);
    } else {
      if (diffInMonths > 3) {
        setTempStartDate(defaultStart);
        setTempEndDate(defaultEnd);
        toast.error("Date range cannot exceed 3 months.");
        setIsFilterLoading(false);
        return;
      }

      setTimeout(() => {
        setStartDate(tempStartDate);
        setEndDate(tempEndDate);
        fetchPaidComissions();
        setIsFilterLoading(false);
      }, 1000);
    }
  }

  const reset = () => {
    setStartDate(defaultStart);
    setEndDate(defaultEnd);
    setTempStartDate(defaultStart);
    setTempEndDate(defaultEnd);
    fetchPaidComissions()
  }

  const {
    companyId,
    user: stateUser,
  } = useSelector((state: RootState) => state.auth)


  const {
    data: commissionAggregate,
    loading: loadingAggregate,
  } = useQuery<CommissionAggregateType>(COMMISSIONAGGREGATENEW, {
    variables: {
      id: companyId,
      code: "BDD",
    },
  })
  // console.log(commissionAggregate)

  const handleSearch = () => {
    search()
  }

  const filterData = (admin: ResponseType) => {
    const isTextMatch =
      admin?.["Transaction Ref"]
        ?.toLowerCase()
        ?.includes(searchText?.toLowerCase()) ||
      admin?.["Policy Number"]
        ?.toLowerCase()
        ?.includes(searchText?.toLowerCase()) ||
      admin?.["Policyholder"]
        ?.toLowerCase()
        ?.includes(searchText?.toLowerCase()) ||
      admin?.["Class/Subclass"]
        ?.toLowerCase()
        ?.includes(searchText?.toLowerCase()) ||
      admin?.["Commission Rate"]
        ?.toLowerCase()
        ?.includes(searchText?.toLowerCase())
    return isTextMatch
  }

  function filterDate(item: ResponseType): boolean {
    const date = new Date(item?.["Transaction Date"]);
    const start = new Date(searchFilterStart);
    const end = new Date(searchFilterEnd);

    return date >= start && date <= end;
  }


  const fetchPaidComissions = async () => {
    try {
      const res = await fetch(
        `${process.env.REACT_APP_BASE_URL}/get-paid-commissions?start_date=${tempStartDate}&end_date=${tempEndDate}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            usertype: DASHBOARD_USERTYPE.company,
            company_id: companyId,
            commission_type: "other",
          }),
        }
      )
      const req = await res.json()
      // console.log("request",req)

      if (res.ok) {
        if (req?.error === 404) {
          setCommissions([])
        } else {
          setCommissions(req?.data)
          setTotalAmount(req?.total_amount ?? 0)

        }
      }
    } catch (error) {
      toast.error("Failed to fetch commissions. Refresh to try again")
    } finally {
      setLoading(false)
    }
    //-------------------------
  }
  //-------------------------

  // console.log(commissions)

  const search = async () => {
    if (searchText) {
      try {
        setIsFilterLoading(true)
        const response = await fetch(
          `${process.env.REACT_APP_BASE_URL}/search-paid-commissions-v2?company_id=${companyId}&search_term=${searchText}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        )

        const req = await response.json()

        if (response.ok) {
          setSearchData(req.data)
          setTotalAmount(req?.total_amount ?? 0)
          toast.success(req?.message)
        } else {
          toast.error(req?.message)
        }
        setIsFilterLoading(false)
      } catch (error) {
        toast.error("Could not perform search")
        setIsFilterLoading(false)
      }
    }
  }

  const [currentPage, setCurrentPage] = useState(0)
  const [itemsPerPage, setItemsPerPage] = useState(10)



  useEffect(() => {
    if (searchText || startDate || endDate || itemsPerPage) {
      setCurrentPage(0)
    }
  }, [searchText, startDate, endDate, itemsPerPage])

  const normalizeDate = (date: Date | string | null | undefined): Date | null => {
    if (!date) return null; // Return null when date is cleared
    const normalizedDate = new Date(date);
    normalizedDate.setHours(0, 0, 0, 0); // Reset time to midnight
    return normalizedDate;
  };

  const displayData = searchData !== undefined ? searchData : commissions

  const filteredCommissions = (searchFilterStart || searchFilterEnd) ? displayData?.filter(filterDate) : displayData
  // ?.filter(filterData)
  const totalItems = filteredCommissions

  // const totoalItems = commissions?.filter(filterData)?.filter((item: any) => {
  //   const from = normalizeDate(startDate);
  //   const to = normalizeDate(endDate);
  //   const dateCreated = normalizeDate(item["Transaction Date"]);

  //   if (from && to) {
  //     return dateCreated && dateCreated >= from && dateCreated <= to;
  //   } else if (from) {
  //     return dateCreated && dateCreated >= from;
  //   } else if (to) {
  //     return dateCreated && dateCreated <= to;
  //   } else {
  //     return true; // If both startDate and endDate are cleared, return all items
  //   }
  // });



  // const paginatedData = totoalItems?.slice(startIndex, endIndex)

  const endOffset = currentPage + itemsPerPage
  const paginatedData = totalItems?.slice(currentPage, endOffset)





  // useEffect(() => {
  //   if (!startDate && !endDate) {
  //     fetchPaidComissions();
  //   }
  // }, [startDate, endDate]);

  useEffect(() => {
    if (startDate && endDate) {
      const start = new Date(startDate);
      const end = new Date(endDate);

      const diffInMonths = (end.getFullYear() - start.getFullYear()) * 12 + (end.getMonth() - start.getMonth());

      if (diffInMonths > 3) {
        // Optionally show an error message or prevent the API call
        toast.error("Date range cannot exceed 3 months.");
        reset()
        return;
      }

      fetchPaidComissions();
    } else if (startDate || endDate) {
      fetchPaidComissions(); // allow one-sided filtering
    }
  }, [startDate, endDate]);


  // const reset =() =>{
  //   setStartDate("");
  //   setEndDate("");
  //   fetchPaidComissions()
  // }


  const handleDownload = () => {
    // Check if there is data to download
    if (totalItems?.length === 0) {
      alert("No data to download.")
      return
    }
    if (selectedThick.length > 0) {
      const type = selectedThick?.map((item: any) => ({
        "transaction ref": item["Transaction Ref"],
        "policy number": item["Policy Number"],
        payee: item["Payee"],
        "class subclass": item["Class/Subclass"],
        premium: `GHS ${(
          parseFloat(item["Basic Premium"] as any) ?? 0
        ).toLocaleString("en-US", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })}`,
        rate: item["Commission Rate"],
        "gross commission": `GHS ${(item["Gross Commission"] ?? 0).toLocaleString("en-US", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })}`,
        "total tax deductions": `GHS ${(
          parseFloat(item["Tax Amount"] as any) ?? 0
        ).toLocaleString("en-US", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })}`,
        "net commission": `GHS ${(
          parseFloat(item['Net Commission'] as any) ?? 0
        ).toLocaleString("en-US", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })}`,
        "transaction date": item["Payment Date"],
      }))
      const firstItem = type[0]
      const originalHeaders = Object.keys(firstItem!)
      const upperHeaders = originalHeaders.map((h) => h.toUpperCase())
      // Transform data to match headers (Simplified)
      const transformedData = type?.map((item) => {
        const transformedItem: Record<string, string> = {};
        originalHeaders.forEach((originalKey, idx) => {
          const upperKey = upperHeaders[idx];
          transformedItem[upperKey] = String(item[originalKey as keyof typeof item]);
        });
        return transformedItem;
      });
      // Convert data to CSV format
      const csvData = Papa.unparse({
        fields: upperHeaders,
        data: transformedData!,
      })
      // Create a Blob and download link
      const blob = new Blob([csvData], { type: "text/csv" })
      const url = window.URL.createObjectURL(blob)
      // Create a download link
      const a = document.createElement("a")
      a.href = url
      a.download = `${"pending-commissions"}.csv`
      document.body.appendChild(a)
      // Trigger a click on the link to start the download
      a.click()
      // Cleanup
      window.URL.revokeObjectURL(url)
      document.body.removeChild(a)
      return

    } else {
      const type = totalItems?.map(
        (item: any) => ({
          "transaction ref": item["Transaction Ref"],
          "policy number": item["Policy Number"],
          payee: item["Payee"],
          "class subclass": item["Class/Subclass"],
          premium: `GHS ${(
            parseFloat(item["Basic Premium"] as any) ?? 0
          ).toLocaleString("en-US", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}`,
          rate: item["Commission Rate"],
          "gross commission": `GHS ${(item["Gross Commission"] ?? 0).toLocaleString("en-US", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}`,
          "total tax deductions": `GHS ${(
            parseFloat(item["Tax Amount"] as any) ?? 0
          ).toLocaleString("en-US", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}`,
          "net commission": `GHS ${(
            parseFloat(item['Net Commission'] as any) ?? 0
          ).toLocaleString("en-US", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}`,
          "transaction date": item["Payment Date"],
        })
      )
      const firstItem = type[0]
      const originalHeaders = Object.keys(firstItem!)
      const upperHeaders = originalHeaders.map((h) => h.toUpperCase())
      // Transform data to match headers (Simplified)
      const transformedData = type?.map((item) => {
        const transformedItem: Record<string, string> = {};
        originalHeaders.forEach((originalKey, idx) => {
          const upperKey = upperHeaders[idx];
          transformedItem[upperKey] = String(item[originalKey as keyof typeof item]);
        });
        return transformedItem;
      });
      // Convert data to CSV format
      const csvData = Papa.unparse({
        fields: upperHeaders,
        data: transformedData!,
      })
      // Create a Blob and download link
      const blob = new Blob([csvData], { type: "text/csv" })
      const url = window.URL.createObjectURL(blob)
      // Create a download link
      const a = document.createElement("a")
      a.href = url
      a.download = `${"paid-commissions"}.csv`
      document.body.appendChild(a)
      // Trigger a click on the link to start the download
      a.click()
      // Cleanup
      window.URL.revokeObjectURL(url)
      document.body.removeChild(a)
    }
  }

  const handlePrint = () => {
    if (paginatedData.length === 0) {
      window.alert("No data to print")
      return
    }
    // Create a new window for printing
    const printWindow = window.open("", "_blank")

    // Construct the content to be printed
    const printContent = `
      <html>
        <head>
          <title>Collection of Paid Commissions</title>
          <style>
            body {
              font-family: Arial, sans-serif;
              padding: 20px;
            }
            h1 {
              text-align: center;
              font-size: 24px;
              margin-bottom: 20px;
            }
            table {
              width: 100%;
              border-collapse: collapse;
              margin-bottom: 20px;
            }
            th, td {
              border: 1px solid #dddddd;
              text-align: left;
              padding: 10px;
            }
            th {
              background-color: #f2f2f2;
              font-weight: bold;
            }
          </style>
        </head>
        <body>
          <h1>Paid Commissions</h1>
          <table>
            <thead>
              <tr>
                <th>Transaction Ref</th>
                <th>Transaction Date</th>
                <th>Policy Number</th>
                <th>Payee</th>
                <th>Class/Subclass</th>
                <th>Basic Premium</th>
                <th>Commission Rate</th>
                <th>Gross Commission</th>
                <th>Tax Amount</th>
                <th>Net Commission</th>
              </tr>
            </thead>
            <tbody>
             ${paginatedData
        .map(
          (rowData) => `<tr>
                <td>${rowData["Transaction Ref"]}</td>
                <td>${moment(rowData["Transaction Date"]).format("LLL")}</td>
                <td>${rowData["Policy Number"]}</td>
                <td>${rowData["Policyholder"]}</td>
                <td>${rowData["Class/Subclass"]}</td>
                <td>GHS ${(
              (rowData?.["Basic Premium"] as any) ?? 0
            ).toLocaleString("en-US", {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })}</td>
                <td>${rowData["Commission Rate"]}%</td>
                <td>GHS ${(
              (rowData?.["Gross Commission"] as any) ?? 0
            ).toLocaleString("en-US", {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })}</td>
                <td>GHS ${(
              (rowData?.["Tax Amount"] as any) ?? 0
            ).toLocaleString("en-US", {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })}</td>
                <td>GHS ${(
              (rowData?.["Net Commission"] as any) ?? 0
            ).toLocaleString("en-US", {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })}</td>
              </tr>
              `
        )
        .join(" ")}
            </tbody>
          </table>
        </body>
      </html>
    `

    // Write the content to the new window
    printWindow!.document.write(printContent)

    // Close the document after printing
    printWindow!.document.close()

    // Print the window
    printWindow!.print()
  }

  const userData = stateUser
  const [colors, setColors] = useState<string[]>()

  useEffect(() => {
    if (userData) {
      // const data: UserType = JSON.parse(userData)

      const colors = getColorCode(stateUser?.colors)

      setColors(colors)
    }
  }, [userData, stateUser?.colors])

  return (
    <>


      <CustomHeader title="Paid commissions" />
      <div className="mb-5 w-full grid-cols-1 grid sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-2 md:lg:gap-4 lg:gap-5">
        <Card className="bg-brand-yellow rounded-lg shadow-sm px-5 py-6 hover:shadow-md hover:cursor-pointer h-full">
          <div className="flex flex-row justify-between text-center">
            <div>
              <Typography className="text-3xl font-bold text-white capitalize tracking-wider">
                {loadingAggregate ? (
                  <Spinner className="mb-2 text-white" />
                ) : (
                  commissionAggregate?.all_types_of_commissios?.length
                )}
              </Typography>
              <Typography className="text-sm uppercase font-normal text-white">
                Commission Types
              </Typography>
            </div>
          </div>
        </Card>
        <Card className="bg-brand-success rounded-lg shadow-sm px-5 py-6 hover:shadow-md hover:cursor-pointer">
          <div className="flex flex-row justify-between text-center">
            <div>
              <Typography className="text-3xl font-bold text-white capitalize tracking-wider">
                {"GH₵ " +
                  (totalAmount).toLocaleString("en-US", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })}

              </Typography>
              <Typography className="text-sm uppercase font-normal text-white">
                Total Paid Commission
              </Typography>
            </div>
          </div>
        </Card>


      </div>

      <div className="mt-10">
        <CardBody className="shadow-sm sticky px-0 py-0  rounded-3xl w-full">
          <div className="bg-black pt-5 rounded-t-2xl">
            <Typography
              variant="h6"
              style={{
                color:
                  colors?.length! > 1
                    ? `${colors![0]?.toLowerCase()}`
                    : `${DEFAULTPRIMARYCOLOR}`,
              }}
              className="px-4 pb-4  font-bold  leading-none opacity-70 capitalize"
            >
              Total paid commissions
              {commissions && (
                <span className="text-white text-sm bg-admin-red p-1 rounded-md">
                  {totalItems?.length}
                </span>
              )}
            </Typography>
          </div>
          <div className="flex flex-col md:flex-row lg:flex-row gap-3 bg-white w-full">
            {/* <div className="w-full">
              <Input
                crossOrigin="anonymous"
                label="Search"
                value={searchText}
                onChange={handleSearch}
                icon={<i className="fas fa-search text-base"></i>}
              />
            </div> */}
            <CardHeader
              floated={false}
              shadow={false}
              className="rounded-none w-full"
            >
              <div className="w-full  flex flex-col gap-y-4 ">
                <div className="flex  justify-end">
                  <div className="flex shrink-0 flex-col gap-2 justify-end sm:flex-row">
                    <Button
                      onClick={handlePrint}
                      size="sm"
                      color="green"
                      className=" px-10 text-[1.0rem]"
                    >
                      Print
                    </Button>
                  </div>
                  <div className="flex shrink-0 flex-col gap-2 justify-end sm:flex-row pl-10">
                    <Tooltip content="Export as CSV">
                      <Button
                        onClick={handleDownload}
                        variant="filled"
                        className="capitalize text-sm font-normal flex flex-wrap gap-2"
                        size="sm"
                      >
                        <FiDownloadCloud size={20} />
                        <span>Download csv</span>
                      </Button>
                    </Tooltip>
                  </div>

                </div>

                <div className="">
                  <div className="p-3 flex gap-x-4 items-center flex-col 2xl:flex-row gap-y-3 mb-3">
                    <div className="w-full flex flex-row gap-x-2">
                      <Input
                        crossOrigin="anonymous"
                        value={searchText}
                        onChange={(e) => {
                          setSearchText(e.target.value)
                          if (e.target.value === "") {
                            setSearchText("")
                            setSearchData(undefined)
                            setSearchFilterStart("")
                            setSearchFilterEnd("")
                          }
                        }}
                        label="Search"
                        icon={<BiSearch className="h-5 w-5" />}
                      />
                      <Button
                        onClick={handleSearch}
                        variant="filled"
                        className="capitalize text-sm font-normal flex flex-wrap items-center justify-center"
                        size="sm"
                      >
                        <span>Search</span>
                      </Button>
                    </div>

                    <div className="flex flex-col xl:flex-row gap-3 justify-between mb-0">
                      <div className="flex items-center space-x-2">
                        <label className="font-semibold text-gray-700">
                          From
                        </label>
                        <Input
                          type="datetime-local"
                          value={tempStartDate} // Remove 'Z' for input value
                          onChange={handleTempStartDateChange}
                          size="md"
                          className="!border-t-blue-gray-200 focus:!border-t-gray-900 w-full"
                          labelProps={{
                            className: "before:content-none after:content-none",
                          }}
                        />
                      </div>
                      <div className="flex items-center space-x-2">
                        <label className="font-semibold text-gray-700">
                          To
                        </label>
                        <Input
                          type="datetime-local"
                          value={tempEndDate} // Remove 'Z' for input value
                          onChange={handleTempEndDateChange}
                          size="md"
                          className="!border-t-blue-gray-200 focus:!border-t-gray-900 w-full"
                          labelProps={{
                            className: "before:content-none after:content-none",
                          }}
                        />
                      </div>
                      <div className="flex items-center space-x-2">
                        <Tooltip content="Apply Date filters">
                          <Button
                            onClick={handleDateChange}
                            variant="filled"
                            className="capitalize text-sm font-normal flex flex-wrap gap-2"
                            size="sm"
                          >
                            <span>Filter</span>
                          </Button>
                        </Tooltip>
                      </div>
                      <div className="flex items-center space-x-2">
                        <Tooltip content="Clear All Date filters">
                          <Button
                            onClick={reset}
                            variant="filled"
                            className="capitalize text-sm font-normal flex flex-wrap gap-2"
                            size="sm"
                          >
                            <span>Clear</span>
                          </Button>
                        </Tooltip>
                      </div>
                      {/* <div className="flex shrink-0 flex-col gap-2 justify-end sm:flex-row">
                        <Button
                          onClick={reset}
                          size="sm"
                          color="blue"
                          className=" px-10 text-[1.0rem]"
                        >
                          Reset
                        </Button>
                      </div> */}
                    </div>
                  </div>
                </div>
              </div>
            </CardHeader>
          </div>
          <CardBody className="px-0 py-0">
            <div
              className="overflow-x-auto overflow-y-auto"
              style={{ maxHeight: "65vh" }}
            >
              {/* //min-w-max  */}
              <table className="w-full bg-white min-w-max table-auto">
                <thead className="bg-white sticky z-50 top-0">
                  <tr>
                    {[
                      "Transaction Ref",
                      "Provider transaction id",
                      "Policy No.",
                      "Class/Subclass",
                      "Risk ID",
                      "Premium",
                      "Rate",
                      "Gross Commission",
                      "Tax",
                      "Net Commission",
                      "Payee",
                      "Payment Date",
                      "Transaction Date",
                    ].map((head) => (
                      <th
                        key={head}
                        className=" border-y border-blue-gray-100 text-black bg-gray-50/50 p-4"
                      >
                        <Typography
                          color="black"
                          className="font-bold text-sm text-black leading-none opacity-70 capitalize"
                        >
                          {head}
                        </Typography>
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {paginatedData?.map((item, index: number) => {
                    const isLast = index === paginatedData?.length - 1
                    const classes = isLast
                      ? "p-4  text-center"
                      : "p-2 border-b-2 border-blue-gray-50 text-center"

                    return (
                      <tr
                        key={item?.["Policy Number"] + index.toString()}
                        className="hover:bg-gray-100 transition-all hover:cursor-pointer h-[4.0rem]"
                      >
                        <td className={classes}>
                          <Typography
                            variant="small"
                            color="blue-gray"
                            className="font-normal text-xs capitalize"
                          >
                            {item["Transaction Ref"]}
                          </Typography>
                        </td>
                        <td className={classes}>
                          <Typography
                            variant="small"
                            color="blue-gray"
                            className="font-normal text-xs capitalize"
                          >
                            {item["Transaction Id"]}
                          </Typography>
                        </td>
                        <td className={classes}>
                          <Typography
                            variant="small"
                            color="blue-gray"
                            className="font-normal text-xs capitalize"
                          >
                            {item["Policy Number"]}
                          </Typography>
                        </td>
                        {/* <td className={classes}>
                      <Typography
                        variant="small"
                        color="blue-gray"
                        className="font-normal text-xs capitalize "
                      >
                        {item?.["Policy Number"]}
                      </Typography>
                    </td> */}
                        {/* <td className={classes}>
                      <Typography
                        variant="small"
                        color="blue-gray"
                        className="font-normal text-xs capitalize"
                      >
                        {`${item?.Policyholder}`}
                      </Typography>
                    </td> */}
                        <td className={classes}>
                          <Typography
                            variant="small"
                            color="blue-gray"
                            className="font-normal text-xs"
                          >
                            {item?.["Class/Subclass"]}
                          </Typography>
                        </td>
                        {/* <td className={classes}>
                      <Typography
                        variant="small"
                        color="blue-gray"
                        className="font-normal text-xs capitalize"
                      >
                        GHS {item?.["Basic Premium"]}
                      </Typography>
                    </td> */}
                        <td className={classes}>
                          <Typography
                            variant="small"
                            color="blue-gray"
                            className="font-normal text-xs"
                          >
                            {item?.RiskID}
                          </Typography>
                        </td>
                        <td className={classes}>
                          <Typography
                            variant="small"
                            color="blue-gray"
                            className="font-normal text-xs capitalize"
                          >
                            GHS {item?.["Basic Premium"]}
                          </Typography>
                        </td>
                        <td className={classes}>
                          <Typography
                            variant="small"
                            color="blue-gray"
                            className="font-normal text-xs capitalize"
                          >
                            {item?.["Commission Rate"]}%
                          </Typography>
                        </td>
                        <td className={classes}>
                          <Typography
                            variant="small"
                            color="blue-gray"
                            className="font-normal text-xs capitalize"
                          >
                            GHS
                            {(
                              (item?.["Gross Commission"] as any) ?? 0
                            ).toLocaleString("en-US", {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })}
                          </Typography>
                        </td>
                        <td className={classes}>
                          <Typography
                            variant="small"
                            color="blue-gray"
                            className="font-normal text-xs capitalize"
                          >
                            GHS
                            {(
                              (item?.["Tax Amount"] as any) ?? 0
                            ).toLocaleString("en-US", {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })}
                          </Typography>
                        </td>
                        <td className={classes}>
                          <Typography
                            variant="small"
                            color="blue-gray"
                            className="font-normal text-xs capitalize"
                          >
                            GHS
                            {(
                              (item?.["Net Commission"] as any) ?? 0
                            ).toLocaleString("en-US", {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })}
                          </Typography>
                        </td>
                        <td className={classes}>
                          <Typography
                            variant="small"
                            color="blue-gray"
                            className="font-normal text-xs"
                          >
                            {item?.Policyholder}
                          </Typography>
                        </td>
                        <td className={classes}>
                          <Typography
                            variant="small"
                            color="blue-gray"
                            className="font-normal text-xs capitalize"
                          >
                            {moment(item?.["Payment Date"]).format("LLL")}
                          </Typography>
                        </td>

                        <td className={classes}>
                          <Typography
                            variant="small"
                            color="blue-gray"
                            className="font-normal text-xs capitalize"
                          >
                            {moment(item?.["Transaction Date"]).format("LLL")}
                          </Typography>
                        </td>


                      </tr>
                    )
                  })}
                </tbody>
              </table>
            </div>
          </CardBody>
          {(loading || isFilterLoading) && (
            <div className="mt-10 flex items-center justify-center">
              <Spinner className="w-10 h-10" />
            </div>
          )}

          {!paginatedData && !loading && (
            <div className="mt-10 flex items-center justify-center">
              <Typography color="white" variant="h6">
                No data found
              </Typography>
            </div>
          )}
        </CardBody>

        {paginatedData?.length! === 0 && !loading && !isFilterLoading && (
          <div className="mt-10 flex items-center justify-center">
            <Typography color="white" variant="h6">
              No data found
            </Typography>
          </div>
        )}

        {paginatedData && paginatedData?.length !== 0 && !loading && !isFilterLoading && (
          // <GeneralPagination
          //   totalItems={totoalItems?.length!}
          //   itemsPerPage={itemsPerPage}
          //   currentPage={currentPage}
          //   onPageChange={handlePageChange}
          // />

          <PerPageAndPagination
            customColor="white"
            total={totalItems?.length! ?? 0}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            perPage={itemsPerPage}
            setPerPage={setItemsPerPage}
          />
        )}


      </div>
    </>
  )
}

export default PaidCommissions
